import type { PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { plantingsEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreatePlantingRequest,
	Planting,
	PlantingFeatureCollection,
	PlantingGeoJSONParams,
	PlantingListParams,
	UpdatePlantingRequest,
} from "../types";

export const plantingsService = {
	async list(params?: PlantingListParams): Promise<PaginatedResponse<Planting>> {
		const response = await apiClient.get<PaginatedResponse<Planting>>(plantingsEndpoints.list, {
			params,
		});
		// keep envelope; table reads res.data.data.items / .meta.total
		return response.data;
	},

	async getGeoJSON(params?: PlantingGeoJSONParams): Promise<PlantingFeatureCollection> {
		const response = await apiClient.get<SuccessResponse<PlantingFeatureCollection>>(
			plantingsEndpoints.geojson,
			{ params }
		);
		return response.data.data;
	},

	async getById(id: string): Promise<Planting> {
		const url = replaceParams(plantingsEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Planting>>(url);
		return response.data.data;
	},

	async create(data: CreatePlantingRequest): Promise<Planting> {
		const response = await apiClient.post<SuccessResponse<Planting>>(
			plantingsEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdatePlantingRequest): Promise<Planting> {
		const url = replaceParams(plantingsEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<Planting>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(plantingsEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
